// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const PanToolOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M16.91 20.67h-5.05a3.1 3.1 0 01-2.23-.96L4 13.79l1.6-1.43a1.53 1.53 0 011.74-.2l1.86.99V5.72a1.96 1.96 0 011.47-1.9c.28-.06.57-.07.85 0C11.6 2.8 12.42 2 13.44 2c.67 0 1.24.33 1.6.85a1.92 1.92 0 012.09.43c.35.36.56.86.56 1.37v.22a1.91 1.91 0 012.12 1.07c.13.26.19.55.19.84v10.77a3.1 3.1 0 01-3.09 3.12zM6.22 13.88l4.52 4.75c.3.3.7.48 1.11.48h5.06c.85 0 1.55-.7 1.55-1.56V6.78a.38.38 0 00-.39-.4.38.38 0 00-.38.4v4.55h-1.55V4.65a.38.38 0 00-.38-.39.38.38 0 00-.39.4v6.67h-1.54V3.95a.38.38 0 00-.39-.4.38.38 0 00-.38.4v7.38H11.5V5.72a.38.38 0 00-.38-.39.39.39 0 00-.39.39v10.01l-4.12-2.2-.4.35z","fill":"currentColor"}}]},"name":"pan-tool","theme":"outlined"};

const PanToolOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={PanToolOutlinedSvg} />;
  PanToolOutlined.displayName = 'PanToolOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(PanToolOutlined);
